module.exports = __webpack_public_path__ + "img/apple_pay_mark_rgb.5a9198d1.svg";